import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_LINK } from "../global/MenuItems";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
} from "firebase/auth";
import { firebaseConfig } from "../loginWithGoogle/fireBaseConfig";

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Function to store user details in localStorage
const storeUserDetails = async (user) => {
  const accessToken = await user.getIdToken();
  const userDetails = {
    uid: user.uid,
    displayName: user.displayName,
    email: user.email,
    photoURL: user.photoURL,
    accessToken,
    refreshToken: user.refreshToken,
    firstName: user.firstName || "",
    lastName: user.lastName || "",
  };

  localStorage.setItem("userDetails", JSON.stringify(userDetails));
};

// Hook for Email & Password Login
export const useEmailLogin = () => {
  const navigate = useNavigate();

  return async (email, password, event) => {
    event.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      await storeUserDetails(userCredential.user);
      navigate("/admin/dashboard");
    } catch (error) {
      console.error("Login Error:", error.message);
    }
  };
};

// Hook for Google Login
export const useGoogleLogin = () => {
  const navigate = useNavigate();
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });

  return async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      await storeUserDetails(result.user);
      navigate("/admin/dashboard");
    } catch (error) {
      console.error("Google Login Error:", error.message);
    }
  };
};

// Initialize Facebook SDK
export const useFacebookSDK = () => {
  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "544252898005879",
        cookie: true,
        xfbml: true,
        version: "v18.0",
      });
    };

    if (!document.getElementById("facebook-jssdk")) {
      (function (d, s, id) {
        let js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    }

    let checkFB = setInterval(() => {
      if (window.FB) {
        clearInterval(checkFB);
      }
    }, 500);
  }, []);
};

// Facebook Login Function
export const useFacebookLogin = () => {
  const navigate = useNavigate();

  return () => {
    if (typeof window.FB === "undefined") {
      return;
    }

    window.FB.login(
      function (response) {
        if (response.authResponse) {
          window.FB.api(
            "/me",
            { fields: "id,name,email,picture" },
            function (userInfo) {
              localStorage.setItem("userDetails", JSON.stringify(userInfo));
              navigate(APP_LINK.DASHBOARD);
            }
          );
        } else {
          console.log("User cancelled login or did not fully authorize.");
        }
      },
      { scope: "public_profile,email" }
    );
  };
};
